/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FileUpload } from '../models/FileUpload';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class FileUploadService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Download a file.
     * @param fileGuid
     * @returns binary OK
     * @throws ApiError
     */
    public downloadFileAsync(
        fileGuid: string,
    ): CancelablePromise<Blob> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/files/{fileGuid}',
            path: {
                'fileGuid': fileGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Download a thumbnail of a file.
     * @param fileGuid
     * @returns binary OK
     * @throws ApiError
     */
    public downloadThumbnail(
        fileGuid: string,
    ): CancelablePromise<Blob> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/files/thumbnail/{fileGuid}',
            path: {
                'fileGuid': fileGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Upload an organization logo image.
     * @param sysOrgGuid The organization GUID to associate the logo with.
     * @param formData
     * @returns FileUpload OK
     * @throws ApiError
     */
    public uploadOrgLogo(
        sysOrgGuid: string,
        formData?: {
            /**
             * The logo image file to upload.
             */
            file?: Blob;
        },
    ): CancelablePromise<FileUpload> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/files/org/{sysOrgGuid}/logo',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Download an organization's logo image. This endpoint allows anonymous access for use in emails.
     * Only serves files that are actually organization logos.
     * @param sysOrgGuid The organization GUID to get the logo for.
     * @returns binary OK
     * @throws ApiError
     */
    public getOrgIcon(
        sysOrgGuid: string,
    ): CancelablePromise<Blob> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/files/{sysOrgGuid}/OrgIcon',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
        });
    }
}
